import { useState } from 'react';

import { claimFreebets, useFreebetsStore } from '@/entities/freebet';
import { toPlayerMessage } from '@/shared/api';
import { openLink } from '@/shared/lib/telegram';

interface ClaimFreebetsApi {
  claim: () => Promise<void>;
  isClaiming: boolean;
  error: string | null;
}

/**
 * Получение Фрибетов.
 *
 * Нажатие ничего не начисляет: право зафиксировано при закрытии цикла,
 * а заявка только открывает диплинк букмекера (ГДД §4.4). Поэтому
 * статус после успеха перезапрашивается — состояние заявки меняет сервер.
 */
export function useClaimFreebets(): ClaimFreebetsApi {
  const load = useFreebetsStore((state) => state.load);
  const [isClaiming, setClaiming] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const claim = async (): Promise<void> => {
    setClaiming(true);
    setError(null);

    try {
      const { deeplink } = await claimFreebets();
      if (deeplink === '') {
        // Диплинк задаётся в админке и может быть не заполнен. Открывать
        // пустую ссылку нельзя — Telegram просто закроет мини-апп.
        setError('Ссылка на букмекера ещё не настроена. Загляни позже.');
        return;
      }
      openLink(deeplink);
      await load({ force: true });
    } catch (cause) {
      setError(toPlayerMessage(cause));
    } finally {
      setClaiming(false);
    }
  };

  return { claim, isClaiming, error };
}
